import { Scene, AmbientLight } from 'three'

const AMBIENT_COLOR = 'white'

export const initializeScene = () => {
  const scene = new Scene()
  scene.name = 'FrameScene'
  const ambientLight = new AmbientLight(AMBIENT_COLOR)
  ambientLight.intensity = 0.5
  scene.add(ambientLight)
  return scene
}
